import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getAllSettings } from 'shared/selectors/app-settings';
import bi from 'shared/bi/bi';

import ContentSlider from 'widget/components/content-slider/content-slider';
import PageList from 'widget/components/page-list/page-list';
import Nav from 'widget/components/nav/nav';
import VideoListItem from 'widget/views/desktop/strip/components/videos/video-list-item/video-list-item';

import styles from './videos.styl';


@connect(state => ({
  videoByIds: getVideosGroupedByIds(state),
  appSettings: getAllSettings(state),
}))
@VODCSSModules(styles)
export default class Videos extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    channelData: React.PropTypes.object,

    containerWidth: React.PropTypes.number,

    videoByIds: React.PropTypes.object,
    videoIdsByPageNumber: React.PropTypes.array,

    thumbnailSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number,
    }),

    onSlideToPrev: React.PropTypes.func,
    onSlideToNext: React.PropTypes.func,
    onPlayRequest: React.PropTypes.func,
    onThumbnailClick: React.PropTypes.func,

    currentVideosPageNumber: React.PropTypes.number,
  };

  componentDidMount() {
    bi.logWidgetSystem('videoList.show.rendered', { previousEventName: 'videoList.show.requested' });
  }

  componentWillReceiveProps({ currentVideosPageNumber }) {
    if (currentVideosPageNumber !== this.props.currentVideosPageNumber) {
      bi.logWidgetSystem('videoList.changePage.rendered', { previousEventName: 'videoList.changePage.requested' });
    }
  }

  @autobind
  renderVideoItem(videoId) {
    const {
      channelData,
      videoByIds,
      thumbnailSize,
      appSettings,
      onThumbnailClick,
      onPlayRequest,
    } = this.props;

    return (
      <VideoListItem {...thumbnailSize}
                     channelData={channelData}
                     videoItem={videoByIds[videoId]}
                     appSettings={appSettings}
                     key={videoId}
                     onClick={onThumbnailClick}
                     onPlayRequest={onPlayRequest} />

    );
  }

  hasPage(pageNum) {
    const { videoIdsByPageNumber } = this.props;
    return Boolean(videoIdsByPageNumber[pageNum]);
  }

  get isPrevPageVisible() {
    const { currentVideosPageNumber } = this.props;
    return this.hasPage(currentVideosPageNumber - 1);
  }

  get isNextPageVisible() {
    const { currentVideosPageNumber } = this.props;
    return this.hasPage(currentVideosPageNumber + 1);
  }

  render() {
    const {
      currentVideosPageNumber,
      videoIdsByPageNumber,
      containerWidth,
      onSlideToPrev,
      onSlideToNext,
    } = this.props;

    return (
      <section styleName="container">
        <ContentSlider width={containerWidth}
                       currentPageNumber={currentVideosPageNumber}>
          <PageList pageWidth={containerWidth}
                    currentPageNumber={currentVideosPageNumber}
                    itemsByPageNumber={videoIdsByPageNumber}
                    renderItem={this.renderVideoItem} />
        </ContentSlider>
        <Nav prevButtonClassName={styles['prev-button']}
             nextButtonClassName={styles['next-button']}
             onPrevClick={onSlideToPrev}
             onNextClick={onSlideToNext}
             isPrevVisible={this.isPrevPageVisible}
             isNextVisible={this.isNextPageVisible} />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/strip/components/videos/videos.js